import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, FlexCenter, HideScrollbar } from '../../../global/commonStyle';

const Group = styled.div`
  width: 100%;
  min-height: 560px;
  height: 100vh;
  background-color: var(--background-secondary);
  margin: auto;
  overflow: auto;
  ${FlexCenter}
  ${mobile_xl(css`
    min-height: 751px;
  `)}
`;

const Content = styled.form`
  width: 100%;
  max-width: 558px;
  ${AlignCenter}
  flex-direction: column;
  background-color: var(--background-secondary);
  gap: var(--space-20);
  ${mobile_xl(css`
    max-width: 100%;
    padding: var(--space-32) var(--space-16);
    gap: var(--space-32);
  `)}
`;

const Icon = styled.div`
  ${AlignCenter}
  cursor: pointer;
  .round-close-icon {
    stroke: var(--text-secondary);
  }
  ${mobile_xl(css`
    .svgIcon {
      width: 40px;
      height: 40px;
    }
  `)}
`;
const Icon1 = styled.div`
  ${AlignCenter}
  cursor: pointer;
`;
const Title = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: var(--space-0);
  ${mobile_xl(css`
    text-align: center;
  `)}
`;

const FormBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  background-color: var(--background-primary);
  border: 1px var(--border-primary);
  box-shadow: var(--shadow-card-hover);
  border-radius: var(--border-radius-8);
  padding: var(--space-20);
  ${mobile_xl(css`
    padding: var(--space-18);
    gap: var(--space-32);
  `)}
`;

const Profile = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-16);
  ${mobile_xl(css`
    margin-top: var(--space-16);
  `)}
`;

const ProfileView = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-6);
  ${mobile_xl(css`
    gap: var(--space-8);
  `)}
`;

const Heading = styled.h2`
  ${Typography.body_lg_medium}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const FormContent = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: var(--space-20);
  ${mobile_xl(css`
    max-width: 100%;
  `)}
`;

const Text = styled.p`
  ${Typography.body_md_medium}
  color:  var(--text-secondary);
  margin: var(--space-0);
  ${mobile_xl(css`
    text-align: center;
  `)}
`;

const SubBlock = styled.div`
  ${mobile_xl(css`
    display: flex;
    flex-direction: column;
    gap: var(--space-24);
  `)}
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  height: 216px;
  margin-bottom: var(--space-16);
  padding-left: var(--space-2);
  ${HideScrollbar}
  ${mobile_xl(css`
    gap: var(--space-8);
    height: 172px;
    margin-bottom: var(--space-0);
  `)}
`;

const Item = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  margin-bottom: var(--space-12);
  :last-child {
    margin-bottom: var(--space-0);
  }
  ${mobile_xl(css`
    margin-bottom: var(--space-0);
    gap: var(--space-8);
    :last-child {
      margin-bottom: var(--space-0);
    }
  `)}
`;

const Label = styled.label`
  width: 100%;
  max-width: 193px;
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  ${mobile_xl(css`
    max-width: 100%;
    :last-child {
      width: 50%;
    }
    :first-child {
      width: 48%;
    }
  `)}
`;

const InputValue = styled.input`
  width: 167px;
  ${Typography.body_lg_medium}
  background-color: var(--background-primary);
  color: var(--text-primary);
  border: 0.5px solid var(--border-primary);
  padding: var(--space-8) var(--space-12);
  border-radius: var(--border-radius-6);
  outline: none;

  &:focus {
    border: 0.5px solid var(--brand-primary);
  }
  ::placeholder {
    color: var(--text-placeholder);
  }
  ${mobile_xl(css`
    width: 100%;
    padding: var(--space-12);
  `)}
`;

const ProfileContent = styled.div`
  ${AlignCenter}
  gap: var(--space-8);
`;

const Items = styled.div`
  display: flex;
  gap: var(--space-18);
  margin-bottom: var(--space-8);

  ${mobile_xl(css`
    gap: var(--space-0);
    margin-bottom: var(--space-0);
    width: 100%;
  `)}
`;

const AddBlock = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
  cursor: pointer;
`;

const TextForm = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
  span {
    ${Typography.body_md}
    color: var(--brand-primary);
    margin: var(--space-0);
  }
`;

const Endblock = styled.div`
  ${FlexBetween}
  gap: var(--space-10);
  ${mobile_xl(css`
    flex-direction: column;
    gap: var(--space-32);
  `)}
`;

const TextFormat = styled.p`
  ${Typography.body_md}
  color: var(--text-secondary);
  margin: var(--space-0);
`;

const RightSide = styled.div`
  ${AlignCenter}
  gap: var(--space-16);
  ${mobile_xl(css`
    width: 100%;
    gap: var(--space-12);
    flex-direction: column-reverse;
    button {
      padding: var(--space-10) var(--space-32);
    }
  `)}
`;

const SkipOption = styled.div<{ disable?: boolean }>`
  ${Typography.body_md_medium}
  color: var(--text-secondary);
  margin: var(--space-0);
  cursor: pointer;
  pointer-events: ${(props) => (props.disable ? 'none' : 'auto')};
`;

export {
  Group,
  Content,
  Icon,
  Title,
  FormBlock,
  Profile,
  ProfileView,
  Heading,
  FormContent,
  Text,
  SubBlock,
  Form,
  Item,
  Label,
  InputValue,
  ProfileContent,
  Items,
  AddBlock,
  TextForm,
  Endblock,
  TextFormat,
  Icon1,
  RightSide,
  SkipOption
};
